
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import React, { useState, useEffect, useRef } from 'react';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { FloatLabel } from 'primereact/floatlabel';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const AddClassNoMasterDialog = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [classNoName, setClassNoName] = useState('');
    const [classNoNameErrText, setClassNoNameErrText] = useState('');
    const [classNoNameErr, setClassNoNameErr] = useState(false);

    const submitButtonRef = useRef(null);
    const classNoRef = useRef(null);
    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        if (props.ID) {
            setClassNoName(props?.masterData?.ClassNo);
        }

        // Ensure focus after modal renders
        setTimeout(() => {
            classNoRef.current?.focus();
        }, 100);
    }, []);



    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        if (props.ID) {
            setClassNoName(props?.masterData?.ClassNo);
        }
    }, []);

    const onCancel = () => {
        props.onCancel();
        setClassNoName('');
    }

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(classNoName)) {
            formIsValid = false;
            setClassNoNameErr(true);
            setClassNoNameErrText("ClassNo Name is required");
        } else {
            setClassNoNameErr(false);
            setClassNoNameErrText("");
        }
        return formIsValid;
    };

    const AddClassNoMaster = async (e) => {
        if (validate(e)) {
            try {
                Loader.show();
                let data = {
                    id: props.ID,
                    ClassNo: classNoName.trim().replace(/\s+/g, ' '),
                    CreatedBy: securityUserID,
                };

                await api
                    .post(APIConstant.path.AddUpdateClassNoMaster, data)
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Loader.hide();
                        onCancel();
                    });
            } catch (err) {
                console.log(err);
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    const handleChange = (e, type) => {
        const value = e.target.value;
        const multiLangValue = value.replace(/[^a-zA-Z0-9\s!@#$%^&*\u0A80-\u0AFF\u0900-\u097F\s]/g, '');
        if (type === 'ClassNoName') {
            setClassNoName(multiLangValue);
        }
    };

    return (
        <div>
            <div className='p-grid'>
                <div className="p-col-12 p-md-12 p-pt-2">
                    <label htmlFor="clasName">Class No<span style={{ color: "red" }}>*</span></label>
                    <div className="custom-inputs">
                        <FloatLabel>
                            <InputText
                                ref={classNoRef}
                                className="p-mt-2 p-pl-2 p-w-100"
                                id="classNoName"
                                type="text"
                                maxLength={20}
                                placeholder="Class No"
                                value={classNoName}
                                onChange={(e) => handleChange(e, 'ClassNoName')}
                                 onKeyDown={(e) => {
                                    if (e.key === 'Tab' && !e.shiftKey) {
                                        e.preventDefault();
                                        if (submitButtonRef.current) {
                                            submitButtonRef.current.focus();
                                        }
                                    }
                                }}
                            />

                        </FloatLabel>
                        <span className="error-msg" style={{ color: 'red' }}>
                            {classNoNameErr ? classNoNameErrText : null}
                        </span>
                    </div>
                </div>
            </div>
            <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
                <Button className='btn-text-action-secondary' onClick={(e) => onCancel()}> cancel </Button>
                <Button ref={submitButtonRef} className='btn-text-action-primary submit-focus' label="Save" severity="secondary" raised onClick={(e) => AddClassNoMaster()} />
            </div>
        </div>
    );
};

export default AddClassNoMasterDialog;
